import { WORKSPACE_SELECTION_ROUTE_NAME, EXTENSION_PREFIX, IS_LOADED_FROM_EXTENSION_PARAM } from '@/router/router.const.js';

const isLoadedFromExtension = (route) =>
	route.matched.some((fatherRoute) => fatherRoute.name?.includes(EXTENSION_PREFIX)) ||
	route.name?.includes(EXTENSION_PREFIX) ||
	route.query[IS_LOADED_FROM_EXTENSION_PARAM];

const isExtensionWorkspaceSelectionRoute = (routeName) => routeName === `${EXTENSION_PREFIX}${WORKSPACE_SELECTION_ROUTE_NAME}`;

const RouterService = {
	isLoadedFromExtension,
	isExtensionWorkspaceSelectionRoute,
};
export default RouterService;
